import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { FormData } from './types';

interface Props {
  formData: FormData;
  onChange: (field: keyof FormData, value: string | string[]) => void;
  onBack: () => void;
  onSubmit: () => Promise<void>;
  submitting: boolean;
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '14px 16px',
  border: '1.5px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '18px',
  fontFamily: "'Zen Maru Gothic', sans-serif",
  outline: 'none',
  color: '#333',
  letterSpacing: '1px',
};

const backBtnStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: '#bbb',
  fontSize: '12px',
  cursor: 'pointer',
  padding: '4px 8px',
  textDecoration: 'underline',
};

export default function StepPhone({ formData, onChange, onBack, onSubmit, submitting }: Props) {
  const [phoneError, setPhoneError] = useState('');

  const validateAndSubmit = () => {
    const normalized = formData.phone.replace(/[-\s]/g, '');
    if (!/^[0-9]{11}$/.test(normalized)) {
      setPhoneError('携帯電話番号を11桁で入力してください（例：09012345678）');
      return;
    }
    setPhoneError('');
    onSubmit();
  };

  return (
    <div>
      <p style={{ fontWeight: 700, fontSize: '15px', marginBottom: '6px', color: '#333' }}>
        Q4. 連絡先の電話番号を入力してください
      </p>
      <p style={{ fontSize: '12px', color: '#aaa', marginBottom: '16px' }}>
        専任アドバイザーよりご連絡いたします
      </p>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ fontSize: '13px', color: '#666', display: 'block', marginBottom: '6px', fontWeight: 600 }}>
          電話番号
          <span style={{ fontSize: '11px', color: '#fa7c9e', marginLeft: '6px' }}>ハイフンなし・11桁</span>
        </label>
        <input
          name="phone"
          type="tel"
          style={inputStyle}
          placeholder="09012345678"
          value={formData.phone}
          inputMode="numeric"
          maxLength={13}
          onChange={(e) => {
            onChange('phone', e.target.value);
            setPhoneError('');
          }}
        />
        {phoneError && (
          <p style={{ color: '#dc3545', fontSize: '12px', marginTop: '6px' }}>{phoneError}</p>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
        <div style={{ textAlign: 'center', width: '100%' }}>
          <p style={{ fontSize: '11px', color: '#ff5c73', marginBottom: '6px', fontWeight: 700 }}>
            完全無料！
          </p>
          <button
            className="btn-next"
            style={{
              width: '100%',
              maxWidth: '320px',
              padding: '16px 24px',
              fontSize: '16px',
              opacity: submitting ? 0.7 : 1,
            }}
            onClick={validateAndSubmit}
            disabled={submitting || !formData.phone}
          >
            {submitting ? '送信中...' : '無料で求人を紹介してもらう'}
          </button>
        </div>
        <button style={backBtnStyle} onClick={onBack} disabled={submitting}>
          ← 前の質問に戻る
        </button>
      </div>
    </div>
  );
}